import { Settings, WidgetData } from "./data"
import { Widget } from "./widget"

export type TableWidgetCell = {
  _id?: string
  text: string
  row?: string
}

export type TableData = WidgetData & {
  settings: Settings & {
    table_header: Array<{ _id?: string, text: string }>,
    table_body: TableWidgetCell[],
  },
  widgetType: "Table"
}

export class TableWidget extends Widget {
  table_header: Array<{text: string}>
  table_body:  TableWidgetCell[][]

  constructor(data: TableData) {
    super(data);

    this.table_header = data.settings.table_header

    this.table_body= []
    let row: TableWidgetCell[] = []
    const table_body = data.settings.table_body
    table_body.forEach((el: TableWidgetCell, index) => {
      if(el?.row === 'yes') {
        this.table_body.push(row)
        row = []
        row.push({text: el.text})
      }
      else if(table_body.length - 1 === index){
        // make sure the last row gets added
        row.push({text: el.text})
        this.table_body.push(row)
      }
      else {
        row.push({text: el.text})
      }
    })
  }
}
